export var ReactEffectType;
(function (ReactEffectType) {
  ReactEffectType[ReactEffectType["Effect"] = 1] = "Effect";
  ReactEffectType[ReactEffectType["LayoutEffect"] = 2] = "LayoutEffect";
})(ReactEffectType || (ReactEffectType = {}));